
import VueFileUpload from 'vue-file-upload';
import jQuery from 'jquery'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { setTimeout } from 'timers'
import nativeApi from '../tool/nativeApi'
export default {
props: {
fileList: Array,
editFlag: {
type: Boolean,
default: true
},








},
watch: {
fileList(val){
this.formatList()
this.files = val
},
files(val){
this.formatList()
this.$emit('update:fileList', val)
}
},
directives: {
TransferDom
},
components: {
VueFileUpload,
Flexbox,
FlexboxItem,
Previewer,
TransferDom,
},
created(){
if(this.fileList&&this.fileList.length>0){
this.formatList()
this.files = this.fileList

}




},
data(){
return{
files:[],

filters:[
{
name:"imageFilter",
fn(file){
var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
}
}
],
pList: [],
fileObj: [],
imgObj: [],
lastClick: new Date().getTime()
}
},
mounted(){

},
methods:{

nativeAddFiled(){
nativeApi.nativeFN.takePhoto((data)=>{
this.files.push(data)
})
},

formatList(){
this.pList = []
this.imgObj = []
this.fileObj = []

this.files.forEach(item => {
item.filePath = item.accessPath?item.accessPath:item.filePath
if(item.fileStoreSystem == 1){
this.imgObj.push(item)
}else if(item.fileStoreSystem == 2){
this.fileObj.push(item)
}
})

this.imgObj.forEach(item => {
this.pList.push({
msrc:item.filePath,
src:item.filePath,
})
});
},


showBigImage(index){

if((new Date().getTime() - this.lastClick)<1000){
return
}
this.lastClick = new Date().getTime()
this.$refs.previewer.show(index)
},

showFile(item){
nativeApi.nativeFN.docViewer(item)
},


delFile(index){
this.files.splice(index,1)
},
delImage(file){
let index = null
this.files.forEach((item,key) => {
if(item.fileId == file.fileId){
index = key
}
});
this.files.splice(index,1)
}


},
}



// WEBPACK FOOTER //
// ./src/common/components/SaafImageUpload.vue